export const menu_usage_store = "menu-usage";

export const updateMenuUsage = ([menuUsage, setMenuUsage], key) => {
  menuUsage[key] = menuUsage[key] || 0;
  menuUsage[key]++;
  setMenuUsage(menuUsage);
};
